import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltroActividades } from 'src/app/shared/models/filtroActividades';
import { AsignacionesService } from 'src/app/core/services/asignaciones/asignaciones.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  spinner = true;
  listRegistros: any[] = [];
  page = 1;
  formDatos: FormGroup;
  total: number;
  totalResults: any[] = [];
  pages_total = 0;
  filtros = new FiltroActividades;
  filtrosCompletados = false;
  constructor(private form: FormBuilder,
    private router: Router,
    private asignacionesService: AsignacionesService,
    private _snackBar: MatSnackBar,) {

    $('#spinner-load').css("display", "block");

    let filtros = localStorage.getItem('filtroActividadesHome')
    if (!filtros) {
      this.filtros = new FiltroActividades();
    } else {
      this.filtros = JSON.parse(filtros);

    }


    this.formDatos = this.form.group({
      numberOT: [this.filtros.numberOT],
      dateFrom: [this.filtros.dateFrom],
      dateUntil: [this.filtros.dateUntil],
      code: [this.filtros.code],
      name: [this.filtros.name],
      section: [this.filtros.section],
      frequency: [this.filtros.frequency],
      state: [this.filtros.state],

    });
    this.changePage(1);

  }



  ngOnInit(): void {

  }

  ngAfterViewInit() {


    $('.ui.dropdown').dropdown({
      "clearable": true
    });

    $('.ui.selection.dropdown').dropdown({
      "clearable": true
    });
  }
  otFilters: any = [];
  utFilters: any = [];
  frequencyFilters: any = [];
  stateFilters: any = [];
  sectionFilters: any = [];
  nameFilters: any = [];
  codeFilters: any = [];
  cargarLista() {
    $('#spinner-load').css("display", "block");

    this.asignacionesService.getAllResults(this.page, 15, this.filtros).subscribe(res => {
      this.listRegistros = res.data;
      this.pages_total = res.totalPages;
      this.otFilters = res.otList;
      this.utFilters = res.denominationList;
      this.sectionFilters = res.sectionList;
      this.nameFilters = res.nameList;
      this.codeFilters = res.codeList;
      this.stateFilters = res.stateUtList;
      this.frequencyFilters = res.frequencyList;
      this.spinner = false;
      $('#spinner-load').css("display", "none");
    },
      error => {
        this._snackBar.open('Ocurrio un error al cargar los datos', 'x', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['error-snackbar'],
        });
        $('#spinner-load').css("display", "none");

      })

  }

  completarFiltros() {

    this.filtrosCompletados = true;

  }


  detalle(item) {
    if (!item.Status.OT) {
      this._snackBar.open('No se encontro el campo OT', 'x', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['yellow-snackbar'],
      });
      return;
    }
    if (!item.Status.CodigoEstacion) {
      this._snackBar.open('No se encontro el campo Codigo', 'x', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['yellow-snackbar'],
      });
      return;
    }
    this.router.navigate(["detalle/" + item.Protocol_Id + "/" + item.Status.OT.Observed + "/" + item.Status.CodigoEstacion.Observed]);
  }



  limpiar() {
    this.filtros = null;
    this.formDatos.controls['numberOT'].setValue(null)
    this.formDatos.controls['dateFrom'].setValue(null)
    this.formDatos.controls['dateUntil'].setValue(null)
    this.formDatos.controls['code'].setValue(null)
    this.formDatos.controls['name'].setValue(null)
    this.formDatos.controls['section'].setValue(null)
    this.formDatos.controls['frequency'].setValue(null)
    this.formDatos.controls['state'].setValue(null)
    this.filtros = new FiltroActividades();
    localStorage.setItem('filtroActividadesHome', JSON.stringify(this.filtros))
    $('.ui.dropdown').dropdown('restore defaults');
    this.changePage(1);

  }

  changePage(number_page: number) {
    this.page = number_page;
    this.cargarLista();
  }

  aplicar() {
    this.filtros = new FiltroActividades();
    this.filtros.numberOT = this.formDatos.get('numberOT').value;
    this.filtros.dateFrom = this.formDatos.get('dateFrom').value;
    this.filtros.dateUntil = this.formDatos.get('dateUntil').value;
    this.filtros.code = this.formDatos.get('code').value;
    this.filtros.name = this.formDatos.get('name').value;
    this.filtros.section = this.formDatos.get('section').value;
    this.filtros.frequency = this.formDatos.get('frequency').value;
    this.filtros.state = this.formDatos.get('state').value;

    localStorage.setItem('filtroActividadesHome', JSON.stringify(this.filtros))

    $('#spinner-load').css("display", "block");

    this.changePage(1);


  }
  setForm(event) {
    this.formDatos.controls[event.name].setValue(event.value)
  }
  changeOrder(value) {
    this.filtros.orderWhen = value;
    this.page = 1;
    this.changePage(1);

  }


}
